// JsFromRoutes CacheKey 6470cc47ac432de40b75095f2cf09351
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/add-contact/:token'),
  update: /* #__PURE__ */ definePathHelper('patch', '/add-contact/:token'),
  preferences: /* #__PURE__ */ definePathHelper('get', '/add-contact/:token/preferences'),
  updatePreferences: /* #__PURE__ */ definePathHelper('patch', '/add-contact/:token/preferences'),
}
